// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__pSW68","select":"Header_select__1mExJ","clinic":"Header_clinic__13Fs1"};